module.exports = __webpack_public_path__ + "img/camiseta-cinza-detalhe.5483bf3b.jpg";